import React, { useEffect, useState, useContext } from "react";
import { DrtContext } from "../../../context/DrtContext";
import axiosBaseURL from "../../../httpCommon";
import { useTitle } from "../../../services/PageTitle";

const ActRules = () => {
  useTitle("Act & Rules")
  const { EncryptDecrypt } = useContext(DrtContext);
  const [about, setabout] = useState([]);

  const getAbout = async () => {
    await axiosBaseURL.get("/site/act-rules").then((result) => {
      const temp = EncryptDecrypt(result.data);
      setabout(temp.data);
    });
  };
  useEffect(() => {
    getAbout();
  }, []);

  if (!about)
    return (
      <>
        <h6 className="loader">Loading......</h6>
      </>
    );

  return (
    <>
      <h6>{about && about.title}</h6>
      <div dangerouslySetInnerHTML={{ __html: about && about.body }}></div>
    </>
  );
};
export default ActRules;
